import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { CheckCircle } from "lucide-react";

const BookingConfirmation = () => {
  return (
    <div className="min-h-screen pt-24 pb-12 bg-secondary">
      <div className="container mx-auto px-4">
        <Card className="max-w-2xl mx-auto border border-primary/20 shadow-lg">
          <CardHeader className="bg-primary/5">
            <div className="flex flex-col items-center text-center space-y-4">
              <CheckCircle className="w-16 h-16 text-primary" />
              <CardTitle className="text-2xl md:text-3xl text-primary-dark">
                Booking Request Received!
              </CardTitle>
            </div>
          </CardHeader>
          <CardContent className="text-center space-y-6 pt-6">
            <p className="text-lg text-gray-700">
              Thank you for choosing Mobile Detail Co. A team member will contact
              you shortly to confirm your appointment details.
            </p>
            <p className="text-gray-700">
              If you have any immediate questions, please don't hesitate to call us
              at (651) 286-9930.
            </p>
            <div className="pt-4">
              <Button asChild className="bg-primary hover:bg-primary-dark text-white">
                <Link to="/">Return to Home</Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default BookingConfirmation;
